const isTaskSection = (item) =>
  item && typeof item === 'object' && Array.isArray(item.tasks);

const hasTaskSections = (tasks = []) => tasks.some(isTaskSection);

const mapTasks = (tasks, callback) => {
  if (!hasTaskSections(tasks)) {
    return tasks.map(callback);
  }

  return tasks.map((section) => ({
    ...section,
    tasks: (section.tasks ?? []).map(callback),
  }));
};

export const markCompleting = (tasks, selectedTaskId) =>
  mapTasks(tasks, (task) =>
    task.id === selectedTaskId
      ? {
          ...task,
          completing: true,
          uncompleting: false,
        }
      : task
  );

export const unmarkCompleting = (tasks, selectedTaskId) =>
  mapTasks(tasks, (task) =>
    task.id === selectedTaskId
      ? {
          ...task,
          completing: false,
          uncompleting: task.uncompleting ?? false,
        }
      : task
  );

export const markUncompleting = (tasks, selectedTaskId) =>
  mapTasks(tasks, (task) =>
    task.id === selectedTaskId
      ? {
          ...task,
          completing: false,
          uncompleting: true,
        }
      : task
  );

export const unmarkUncompleting = (tasks, selectedTaskId) =>
  mapTasks(tasks, (task) =>
    task.id === selectedTaskId
      ? {
          ...task,
          completing: task.completing ?? false,
          uncompleting: false,
        }
      : task
  );

export const removeTaskById = (tasks, selectedTaskId) => {
  if (!hasTaskSections(tasks)) {
    return tasks.filter((task) => task.id !== selectedTaskId);
  }

  return tasks
    .map((section) => ({
      ...section,
      tasks: (section.tasks ?? []).filter((task) => task.id !== selectedTaskId),
    }))
    .filter((section) => section.tasks.length > 0);
};
